import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, FormattedPlural } from "react-intl";
import classNames from "classnames";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";
import "./LuggageSummaryRecap.scss";
import { luggageShape } from "app/utils/propTypes";
import {
	BaggageMFilledIcon,
	BaggageLFilledIcon,
	BaggageMDisabledFilledIcon,
	BaggageLDisabledStrokeIcon,
} from "app/icons/travel";

const LuggageSummaryRecap = ({
	bookingLuggageCount,
	luggageMaxCount,
	isLoading,
	flightLuggageOption = {},
}) => {
	const cabinLuggageDetails = flightLuggageOption?.cabinBaggage?.details;
	const holdLuggageDetails = flightLuggageOption?.details;
	const totalLuggageCount = flightLuggageOption?.quantity;

	let luggageCount = 0;

	if (bookingLuggageCount) {
		luggageCount = bookingLuggageCount;
	} else if (totalLuggageCount) {
		luggageCount = totalLuggageCount;
	} else if (flightLuggageOption?.included) {
		const luggageMaxCountPerPassenger = Math.floor(totalLuggageCount / luggageMaxCount);
		luggageCount = totalLuggageCount ? luggageMaxCountPerPassenger : 1;
	} else if (flightLuggageOption?.canBeBooked) {
		luggageCount = 0;
	}

	const isCabinLuggageNotIncluded = flightLuggageOption?.cabinBaggage?.included === false;

	const cabinLuggageClassName = classNames("luggage-summary-recap--item", {
		"luggage-summary-recap--item-included": !isCabinLuggageNotIncluded,
	});

	const holdLuggageClassName = classNames("luggage-summary-recap--item", {
		"luggage-summary-recap--item-included": luggageCount > 0,
	});

	const cabinLuggageCountClassName = classNames("luggage-summary-recap__count", {
		"luggage-summary-recap__count--included": !isCabinLuggageNotIncluded,
	});

	const holdLuggageCountClassName = classNames("luggage-summary-recap__count", {
		"luggage-summary-recap__count--included": luggageCount > 0,
	});

	return (
		<div className="luggage-summary-recap">
			{isLoading ? (
				<>
					<div className="luggage-summary-recap__loader">
						<div className="luggage-summary-recap__loader-icon">
							<BaggageMFilledIcon />
						</div>
						<LoaderBar height={8} width={130} />
					</div>
					<div className="luggage-summary-recap__loader">
						<div className="luggage-summary-recap__loader-icon">
							<BaggageLFilledIcon />
						</div>
						<LoaderBar height={8} width={130} />
					</div>
				</>
			) : (
				<>
					{/* BAGAGE EN CABINE */}
					<div className={cabinLuggageClassName}>
						<span className="luggage-summary-recap__icon">
							{!isCabinLuggageNotIncluded ? (
								<BaggageMFilledIcon />
							) : (
								<BaggageMDisabledFilledIcon />
							)}
						</span>
						<span
							className="luggage-summary-recap__label"
							data-testid="luggage-summary-recap-cabin-label"
						>
							{luggageMaxCount >= 0 && (
								<span
									className={cabinLuggageCountClassName}
									data-testid="cabin-luggage-summary-count"
								>
									{isCabinLuggageNotIncluded ? 0 : luggageMaxCount}x{" "}
								</span>
							)}
							<FormattedPlural
								value={isCabinLuggageNotIncluded ? 0 : luggageMaxCount}
								one={
									<FormattedMessage id="quotation.luggage.cabin.singular.label" />
								}
								other={
									<FormattedMessage id="quotation.luggage.cabin.plural.label" />
								}
							/>

							{cabinLuggageDetails && ` (${cabinLuggageDetails})`}
						</span>
					</div>
					{/* BAGAGE EN SOUTE */}
					<div className={holdLuggageClassName}>
						<span className="luggage-summary-recap__icon">
							{luggageCount > 0 ? (
								<BaggageLFilledIcon />
							) : (
								<BaggageLDisabledStrokeIcon />
							)}
						</span>
						<span
							className="luggage-summary-recap__label"
							data-testid="luggage-summary-label"
						>
							<span
								className={holdLuggageCountClassName}
								data-testid="hold-luggage-summary-count"
							>
								{luggageCount}x{" "}
							</span>{" "}
							<FormattedPlural
								value={luggageCount}
								one={<FormattedMessage id="quotation.luggage.singular.label" />}
								other={<FormattedMessage id="quotation.luggage.plural.label" />}
							/>{" "}
							{holdLuggageDetails && `(${holdLuggageDetails})`}
						</span>
					</div>
				</>
			)}
		</div>
	);
};
LuggageSummaryRecap.propTypes = {
	bookingLuggageCount: PropTypes.number,
	luggageMaxCount: PropTypes.number,
	isLoading: PropTypes.bool,
	flightLuggageOption: luggageShape,
};
export default memo(LuggageSummaryRecap);
